import React from 'react';
//import 'bootstrap/dist/css/bootstrap.min.css';

export default function About() {
  return (
    <div className="container py-5">
      <div className="row align-items-center">
        <div className="col-md-6 mb-4 mb-md-0">
        </div>
        <div className="col-md-6">
          <h2 className="mb-3">About Me</h2>
          <p className="lead">
            I'm Akshat Kumar Gupta, a Full Stack Web Developer with hands-on experience in JavaScript, React, Bootstrap, and database technologies. I love building modern, responsive websites and helping others simplify complex tech through my initiative B.Tech Simplified.
          </p>
          <p>
            I've developed several projects like HackXpert, Virtual Herbal Garden, and Netflix Clone. I'm currently a 3rd-year BCA student and actively participate in hackathons to sharpen my skills and collaborate with others.
          </p>
          <a href="https://v0-akshat-kumar-gupta-website.vercel.app/" className="btn btn-primary mt-3">
            View My Projects
          </a>
        </div>
      </div>
    </div>
  );
};